export const TRAINING_DATE_HELPER_TEXT =
  'If you know when the training will take place, you can add the training date now. Otherwise, you can add the date in the Fall.'

export const SESSION_DATES_HELPER_TEXT =
  'If you know when the sessions will take place, you can add the session dates now. Otherwise, you can add the dates in the Fall.'
